import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

@Injectable()
export class UpdateFeatureService {
  private getConfigURL = '../incidencia.json';


  constructor(private http: Http) { }

  send(formSerializeParams: Object): Promise<string> {
    const urlSearchParams = new URLSearchParams();
    for (const attr in formSerializeParams) {
      urlSearchParams.append(attr, formSerializeParams[attr]);
    }
    const body = urlSearchParams.toString();
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');
    return this.http.post(this.getConfigURL, body, {
      headers: headers
    }).toPromise()
      .then(response => {
        const json = response.json();
        return json.errorMessage;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/data/update-feature.service.ts